import React, { memo } from 'react';
import CheckBoxAsToggle from '@lib/components/CheckBoxAsToggle/CheckBoxAsToggle';
import { CheckboxSizes } from '@lib/components/CheckBox/enums';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import styles from './ToggleCell.module.scss';

export type ToggleCellProps = {
  id: string | number;
  checked: boolean;
  disabled: boolean;
  onChange: (next: boolean) => void;
  labelChecked: string;
  labelUnchecked: string;
  labelDisabled: string;
  tooltipBodyChecked: string;
  tooltipBodyUnchecked: string;
  tooltipBodyDisabled: string;
};

function ToggleCell({
  id,
  checked,
  disabled,
  onChange,
  labelChecked,
  labelUnchecked,
  labelDisabled,
  tooltipBodyChecked,
  tooltipBodyUnchecked,
  tooltipBodyDisabled,
}: ToggleCellProps) {
  let label = labelUnchecked;
  if (disabled) {
    label = labelDisabled;
  } else if (checked) {
    label = labelChecked;
  }
  let tooltipBody = tooltipBodyUnchecked;
  if (disabled) {
    tooltipBody = tooltipBodyDisabled;
  } else if (checked) {
    tooltipBody = tooltipBodyChecked;
  }
  return (
    <div>
      <Tooltip body={tooltipBody} contentClassName={styles.toggleWrapper}>
        <CheckBoxAsToggle
          id={`toggle-cell-${id}`}
          name={`toggle-cell-${id}`}
          size={CheckboxSizes.Small}
          checked={disabled ? false : checked}
          disabled={disabled}
          onChange={() => onChange(!checked)}
          label={label}
          labelTypographyProps={{ variant: 'caption', strong: false }}
        />
      </Tooltip>
    </div>
  );
}

export default memo(ToggleCell);
